import { ReactComponent as LineageIcon } from '@elementary/common-ui/assets/lineage-nav-button-2.svg';
import { Flex, WidgetButton } from '@elementary/common-ui/components';
import { TREE_NODE } from '@elementary/common-ui/constants/urlParams';
import useSearchParams from '@elementary/common-ui/hooks/useSearchParams';
import useNavigateWithEnv from 'shared/hooks/useNavigateWithEnv';

const ActionsColumnRenderer = ({ columnId }: { columnId: string }) => {
  const navigate = useNavigateWithEnv();
  const [searchParams] = useSearchParams();

  const lineageSearchParams = new URLSearchParams(searchParams);
  const treeNodeParam = JSON.parse(lineageSearchParams.get(TREE_NODE) || '{}');
  lineageSearchParams.set(
    TREE_NODE,
    JSON.stringify({ ...treeNodeParam, columnId, columnType: 'column' }),
  );

  return (
    <Flex sx={{ gap: 1, justifyContent: 'flex-end' }}>
      <WidgetButton
        startIcon={<LineageIcon height={12} />}
        onClick={() => navigate(`/report/lineage?${lineageSearchParams}`)}
      >
        Lineage
      </WidgetButton>
    </Flex>
  );
};

export default ActionsColumnRenderer;
